import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { City } from '@/new-transport/_models/transport-map.model';
import { environment } from '../../../environments/environment';
import { Result } from '@/reservation/reservation.model';
import {
	LinkTransportsResponse,
	StopKind,
	TransportKind,
	TransportSide,
} from '@/new-transport/_models/transport.model';
import { OfferTransportKind } from '@/common/enums/OfferTransportKind';

export interface TransportLogic {
	id?: number;
	vehicle: number;
	city: number;
	originCity: number;
	stopDestination: number;
	action: string;
	occupiedSpace: number;
	order: number;
	reservationOfferSlots: number[];
}

export interface SaveTransportMapPayload {
	name: string;
	side: TransportSide;
	kind: TransportKind;
	linked: boolean;
	departureTerms: number[];
	returnTerms: number[];
	transportsToLink: number[];
	transportlogicSet: TransportLogic[];
}

export interface UpdateTransportMapPayload extends SaveTransportMapPayload {
	id: number;
}

@Injectable({
	providedIn: 'root',
})
export class TransportMapApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	getStops(kind: OfferTransportKind): Observable<City[]> {
		return this.httpClient
			.get<
				Result<City>
			>(`${this.apiUrl}/transport/stop/basic/?stop_type=${StopKind.BOARDING},${StopKind.BORDER}&kind=${kind}&limit=9999`)
			.pipe(map((response) => response?.results));
	}

	saveTransportMap(payload: SaveTransportMapPayload): Observable<number> {
		return this.httpClient
			.post<{ id: number }>(`${this.apiUrl}/transport/create_new/`, payload)
			.pipe(map((result) => result.id));
	}

	updateTransportMap(payload: UpdateTransportMapPayload): Observable<number> {
		return this.httpClient
			.put<{ id: number }>(`${this.apiUrl}/transport/${payload.id}/update_new/`, payload)
			.pipe(map((result) => result.id));
	}

	linkTransports(transportsToLink: number[], transportId: number): Observable<LinkTransportsResponse> {
		return this.httpClient.post<LinkTransportsResponse>(`${this.apiUrl}/transport/link/`, {
			baseTransports: transportsToLink,
			targetTransport: transportId,
		});
	}
}
